export default "&nbsp;<a *ngIf=\"dataTable\" (click)=\"onSort()\" style=\"cursor: pointer\"><span class=\"fas fa-sort\" [id]=\"getSortId()\"></span></a>\r\n"